module.exports = __webpack_public_path__ + "img/E1 UP1.9990657c.png";